import {
  GET_REPORTS_DASHBOARD_DATA_WATCHER,
  GET_REPORTS_DASHBOARD_DATA_SUCCESS,
  GET_REPORTS_DASHBOARD_DATA_FAILED,
  GET_DIVISIONS_AMBASSADOR_WATCHER,
  GET_DIVISIONS_AMBASSADOR_SUCCESS,
  GET_DIVISIONS_AMBASSADOR_FAILED,
  GET_SELECTED_DIVISION_WATCHER,
  GET_SELECTED_DIVISION_SUCCESS,
  GET_SELECTED_DIVISION_FAILED,
} from "./constants"

export function getSelectedDivisionWatcher(payload) {
  return {
    type: GET_SELECTED_DIVISION_WATCHER,
    payload,
  }
}

export function getSelectedDivisionSuccess(payload) {
  return {
    type: GET_SELECTED_DIVISION_SUCCESS,
    payload,
  }
}

export function getSelectedDivisionFailed(payload) {
  return {
    type: GET_SELECTED_DIVISION_FAILED,
    payload,
  }
}

export function getAmbassadorDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_AMBASSADOR_WATCHER,
    payload,
  }
}

export function getAmbassadorDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_AMBASSADOR_SUCCESS,
    payload,
  }
}

export function getAmbassadorDivisionsFailed(payload) {
  return {
    type: GET_DIVISIONS_AMBASSADOR_FAILED,
    payload,
  }
}

export function getReportsDashboardDataWatcher(payload) {
  return {
    type: GET_REPORTS_DASHBOARD_DATA_WATCHER,
    payload,
  }
}

export function getReportsDashboardDataSuccess(payload) {
  return {
    type: GET_REPORTS_DASHBOARD_DATA_SUCCESS,
    payload,
  }
}

export function getReportsDashboardDataFailed(payload) {
  return {
    type: GET_REPORTS_DASHBOARD_DATA_FAILED,
    payload,
  }
}
